module.exports = __webpack_public_path__ + "image/pro_icon7.png";